import Frame from "../components/Frame";
import { CheckIcon, EyeIcon } from "../components/Icons";
import ui from "../components/ui.module.css";

// Attention goes back to the teacher. No next activity, no rewards loop.
const Complete = () => (
  <Frame centered>
    <span className={`${ui.bigIcon} ${ui.pop}`}>
      <CheckIcon size={72} />
    </span>
    <h1 className={ui.learnerTitle}>Great work!</h1>
    <p className={ui.subline}>
      <EyeIcon size={28} />
      Look at your teacher.
    </p>
  </Frame>
);

export default Complete;
